import script from "./object_gallery.vue?vue&type=script&setup=true&lang=js"
export * from "./object_gallery.vue?vue&type=script&setup=true&lang=js"

import "./object_gallery.vue?vue&type=style&index=0&id=68e0a03c&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68e0a03c"]])

export default __exports__